// extracted by mini-css-extract-plugin
export default {"grid":"Outside_grid__cuLJV","item":"Outside_item__uzfL3","staff":"Outside_staff__dc+V4","icon":"Outside_icon__2LAwL"};